import { apiTypes } from "../utils/apiTypes";
import axiosInstance from "./axios";

const apiRequestType = async (
  type,
  apiUrl,
  payload,
  cancelToken,
  customConfig
) => {
  try {
    let config;
    const securityProviderName = localStorage.getItem("SecurityProviderName");
    if (customConfig) {
      const { headers, ...rest } = customConfig;
      if (securityProviderName === "aad") {
        config = {
          headers: {
            ...headers,
            Authorization: localStorage.getItem("token"),
            TenantSlugName: localStorage.getItem("tenantName"),
          },
          cancelToken: cancelToken?.token,
          rest,
        };
      } else {
        config = {
          headers: {
            ...headers,
            AuthenticationToken: localStorage.getItem("token"),
            TenantSlugName: localStorage.getItem("tenantName"),
          },
          cancelToken: cancelToken?.token,
          rest,
        };
      }
    } else {
      if (securityProviderName === "aad") {
        config = {
          headers: {
            Authorization: localStorage.getItem("token"),
            TenantSlugName: localStorage.getItem("tenantName"),
          },
          cancelToken: cancelToken?.token,
        };
      } else {
        config = {
          headers: {
            AuthenticationToken: localStorage.getItem("token"),
            TenantSlugName: localStorage.getItem("tenantName"),
          },
          cancelToken: cancelToken?.token,
        };
      }
    }
    if (type === apiTypes.GET) {
      return await axiosInstance
        .get(apiUrl, config)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    } else if (type === apiTypes.POST) {
      return await axiosInstance
        .post(apiUrl, payload, config)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    } else if (type === apiTypes.PUT) {
      return await axiosInstance
        .put(apiUrl, payload, config)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    } else if (type === apiTypes.DELETE) {
      return await axiosInstance
        .delete(apiUrl, config)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export default apiRequestType;
